const OrSeparator = () => (
  <div className='d-flex align-items-center my-4'>
    <hr className='flex-grow-1' />
    <span className='px-4 text-muted'>OR</span>
    <hr className='flex-grow-1' />
  </div>
)

export default OrSeparator